import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { EcommerceService } from 'src/app/services/ecommerce.service';

@Component({
  selector: 'app-image-library',
  templateUrl: './image-library.component.html',
  styleUrls: ['./image-library.component.scss']
})
export class ImageLibraryComponent implements OnInit {
  @Input() storeId: string = '';

  images: any[] = [];
  isLoading = false;
  isUploading = false;
  dragOver = false;

  constructor(
    private ecommerceService: EcommerceService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadImages();
  }

  loadImages(): void {
    this.isLoading = true;
    this.ecommerceService.listGlobalImages(this.storeId).subscribe({
      next: (res: any) => {
        this.images = res?.response?.data || res?.data || [];
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        this.toastr.error(err.error?.response?.message || 'Failed to load images');
      }
    });
  }

  onFilesSelected(event: any): void {
    if (event.target.files?.length) {
      this.uploadImages(event.target.files);
      event.target.value = '';
    }
  }

  onDrop(event: DragEvent): void {
    if (event.dataTransfer?.files?.length) {
      this.uploadImages(event.dataTransfer.files);
    }
  }

  uploadImages(files: FileList): void {
    const formData = new FormData();
    Array.from(files).forEach(file => formData.append('images', file));

    this.isUploading = true;
    this.ecommerceService.uploadGlobalImages(this.storeId, formData).subscribe({
      next: () => {
        this.isUploading = false;
        this.toastr.success('Images uploaded successfully');
        this.loadImages();
      },
      error: (err: any) => {
        this.isUploading = false;
        this.toastr.error(err.error?.response?.message || 'Upload failed');
      }
    });
  }

  deleteImage(filename: string): void {
    Swal.fire({
      title: 'Delete image?',
      text: `"${filename}" will be permanently deleted.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Delete',
      confirmButtonColor: '#dc3545'
    }).then(result => {
      if (result.isConfirmed) {
        this.ecommerceService.deleteGlobalImage(this.storeId, filename).subscribe({
          next: () => {
            this.toastr.success('Image deleted');
            this.loadImages();
          },
          error: (err: any) => {
            this.toastr.error(err.error?.response?.message || 'Delete failed');
          }
        });
      }
    });
  }

  copyFilename(filename: string): void {
    navigator.clipboard.writeText(filename).then(() => {
      this.toastr.info('Filename copied');
    });
  }

  copyUrl(url: string): void {
    navigator.clipboard.writeText(url).then(() => {
      this.toastr.info('URL copied');
    });
  }
}
